import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LeadTypeClass } from '../model/LeadType';
import { AdobeDTM } from '../services/adobe-dtm.service';
import { getParamsType } from '../model/getParamsType';
import { FormControlsAndLogicsService } from '../services/form-controls-and-logics-service.service';
import { SharedService } from '../services/shared.service';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
import { DatePipe } from '@angular/common';


@Component({
    selector: 'app-clinic-submitted',
    templateUrl: './clinic-submitted.component.html',
    styleUrls: ['./clinic-submitted.component.scss'],
    standalone: false
})
export class ClinicSubmittedComponent implements OnInit,AfterViewInit {
  @ViewChild('focus2') myInputt: ElementRef;
  leadId:any;
  
//clinic details
 isMobile:boolean=false;
aci_ismultidayclinic=false;
aci_isthereaspecificdateyoudliketohold=false;
aci_isthereaspecificdate='07/11/2022 - 07/14/2022';
aci_proposedtimeofdays="Morning";
aci_clinicName="test";
aci_cliniccontactname="clinic contact name";
aci_onsitecontactlastname="lastname";
aci_cliniccontactphonenumber="12345";
aci_serviceImmunizatin="COVID-19, A1C Testing, Flu, Shingles";
aci_streetaddress="test test";
aci_monday=false;
aci_tuesday=false;
aci_wednesday=false;
aci_thursday=false;
aci_friday=false;
aci_saturday=false;
aci_sunday=false;
clinicsList = ([] as any[]);
learnMoreVeribage :any= "https://b2b.albertsonscompanies.com/vaccine-clinics.html";
servicesListForLead : Array<string> = [];
  constructor( private router: Router, private route:ActivatedRoute,
    public sharedService: SharedService,
    private renderer: Renderer2,
    public datepipe: DatePipe, 
    private formBuilder: FormBuilder,
    private leadTypeClass: LeadTypeClass,
    private adobeDTM: AdobeDTM,
    private fornControlsObj: FormControlsAndLogicsService,
    protected $gaService: GoogleAnalyticsService,
    private elem: ElementRef
    ) { }

  ngOnInit(): void {
    this.myInputt.nativeElement.focus();
    var device = this.$gaService.mobileOrLaptopdevice();
    if(device.toLowerCase()=="mobile"){
          this.isMobile=true;
         this.elem.nativeElement.focus();
    }
    this.route.paramMap.subscribe((params:ParamMap)=>{
      this.leadId=params.get('id');
      // this.showImmunization = params.get('immuneType');
      // this.showDTS = params.get('serviceType');

       if(this.leadId)
       this.getLeadDetails();
       this.UpdateStatus();
    })
  

  }

 
  

  ngAfterViewInit(): void {
    this.myInputt.nativeElement.focus();
    // setTimeout(() => {this.myInputt.nativeElement.focus()},5000);
    var device = this.$gaService.mobileOrLaptopdevice();

    if(device.toLowerCase()=="mobile"){
          this.isMobile=true;
          this.myInputt.nativeElement.focus();
    }
    this.route.paramMap.subscribe((params:ParamMap)=>{
      this.leadId=params.get('id');

       if(this.leadId)     
       this.getLeadDetails();
       this.UpdateStatus();
    })
    // .$gaService
    // .eventEmitter("clinic-details");
  }

  
  UpdateStatus(){
    const relativePath:string=`groupclinic/updateClinicLead`;
    const getParams={
      entityName: "lead",
      entityId: this.leadId,
      statuscode : 100000000
    }
   this.sharedService.postRequest(relativePath,getParams).subscribe(response=>{
      //this.zipCodes = response.value;
      console.log(response);
    },
    errorResponse => {
      console.log(errorResponse);
    })
  }

  bindClinicDataByLead(response:any){
    this.clinicsList.forEach(element => {
      element.aci_isthereaspecificdate = element.aci_isthereaspecificdateyoudliketohold ? this.datepipe.transform(element.aci_isthereaspecificdate, 'MM/dd/YYYY') : 'NO';
    });
  }

  
  getLeadDetails() {
    const url: string = `groupclinic/getClinicByLeadId`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: this.leadId,
      columns:
        'aci_clinicid,aci_clinictype,aci_immunizationtype,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday,aci_isthereaspecificdateyoudliketohold,aci_estimateofdoses,aci_clinicnoteimportantinformation',
    };
    this.sharedService.postRequest(url, getParams).subscribe({
     next: (response) => {
        if (response != null) {
          this.clinicsList = response.value;
          this.bindClinicDataByLead(this.clinicsList);

        }
      },
     error: (errorResponse) => {
      
        console.log(errorResponse);
      }
    }
    );
  }


  clinicDetails(){
    this.router.navigateByUrl('/contact');
  }

//   getLeadDetails(){

    
// const urlClinic: string = `groupclinic/getClinicByLeadId`;
// const getParams12: getParamsType = {
//   entityName: 'aci_clinic',
//   entityId: this.leadId,
//   columns:
//     'aci_clinictype,aci_immunizationtype,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday',
//     //aci_clinicName,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday
// };
// this.sharedService.postRequest(urlClinic, getParams12).subscribe({
//   next:(response)=>{
//     response=response.value[0];
//     if(response.aci_clinicname)  {
//       this.aci_clinicName=response.aci_clinicname;
//       this.aci_cliniccontactname=response.aci_cliniccontactname;
//       this.aci_onsitecontactlastname=response.aci_onsitecontactlastname;
//       this.aci_cliniccontactphonenumber=response.aci_cliniccontactphonenumber
//       this.aci_streetaddress=response.aci_streetaddress;
//       this.aci_monday=response.aci_monday;
//       this.aci_tuesday=response.aci_tuesday;
//       this.aci_wednesday=response.aci_wednesday;
//       this.aci_thursday=response.aci_thursday;
//       this.aci_friday=response.aci_friday;
//       this.aci_saturday=response.aci_saturday;
//       this.aci_sunday=response.aci_sunday;
//       this.aci_isthereaspecificdate= response.aci_isthereaspecificdate;
//     }

// //     services = [
// //       {name: 'COVID-19',islected:false} ,             
// //       {name: 'Flu',   islected:false} ,
// //       {name: 'Pneumonia',islected:false},
// //       {name: 'Shingles',   islected:false} ,
// //       {name: 'Tetanus',islected:false},
// //       {name: 'Hepatitis B',   islected:false} 
// //      ];

// // screeningArray = [{name: 'A1C',islected:false},
// //      {name: 'Blood Glucose',islected:false} ,
// //      {name: 'Cholesterol/Lipid Panel',islected:false}
// //     ];   

// // additionalServicesArray = [{name: 'Covid-19 Testing',islected:false},
// //     {name: 'Travel Health',islected:false}
// //    ];  

//     if (response.aci_immunizationtype) {
//       let immunizationArray = response.aci_immunizationtype.split(',');
//       immunizationArray.map((row: any) => {
//         if (row == '805170000') {
//           this.aci_serviceImmunizatin+="COVID-19, ";
//         }
//         if (row == '805170001') {
//           this.aci_serviceImmunizatin+="Flu, ";
//         }
//         if (row == '805170003') {
//           this.aci_serviceImmunizatin+="Shingles, ";
//         }
//         if (row == '805170004') {
//           this.aci_serviceImmunizatin+="Tetanus, ";
//         }
//         if (row == '805170005') {
//           this.aci_serviceImmunizatin+="Pneumonia, ";
//         }
//         if (row == '805170006') {
//           this.aci_serviceImmunizatin+="Pneumonia, ";
//         }
//       });
//     }
    
    
//     if (response.aci_clinicservicetype) {
//       let serviceArray = response.aci_clinicservicetype.split(',');
//       serviceArray.map((row: any) => {
//         if (row == '805170000') {
//           this.aci_serviceImmunizatin+="Covid-19 Testing, ";
//         }
//         if (row == '805170006') {
//           this.aci_serviceImmunizatin+="Covid-19 Testing, ";
//         }
//         if (row == '805170005') {
//           this.aci_serviceImmunizatin+="Covid-19 Testing, ";
//         }
//         if (row == '805170001') {
//           this.aci_serviceImmunizatin+="A1C, ";
//         }
//         if (row == '805170002') {
//           this.aci_serviceImmunizatin+="Cholesterol/Lipid Panel, ";
//         }
//         if (row == '805170003') {
//           this.aci_serviceImmunizatin+="Blood Glucose, ";
//         }
        
//       });
//     }
//   },
//   error:()=>{}
  

// })

//   }

}
